import React from 'react';
import DoNotDisturbAltIcon from '@mui/icons-material/DoNotDisturbAlt';
import Toggle from '../utils/Toggle';
import {
    MELEE_PER_DMG_ID, POSITION_MELEE, POSITION_NONE, POSITION_RANGED, RANGED_PER_DMG_ID, STATS,
} from '../../core/st';
import './PositionToggle.css';

const TXT_POSITION = { fr: 'Portée des attaques', en: 'Attack range', de: 'Angriffsreichweite', es: 'Alcance de los ataques', pt: 'Alcance dos ataques' };
const TXT_NONE = { fr: 'Aucun', en: 'None', de: 'Keine', es: 'Ninguno', pt: 'Nenhum' };
const TXT_MELEE = { fr: 'Dégâts en mêlée', en: 'Melee damage', de: 'Nahkampfschaden', es: 'Daños cuerpo a cuerpo', pt: 'Danos corpo a corpo' };
const TXT_RANGED = { fr: 'Dégâts à distance', en: 'Ranged damage', de: 'Fernkampfschaden', es: 'Daños a distancia', pt: 'Danos à distância' };

const tr = (txt, lang) => txt[lang] || txt.en;

// The game's own % Melee / % Ranged damage icons, as the stat sheet shows them.
const statIcon = (id) => (
    <img className="position-toggle-icon" src={STATS.find((s) => s.id === id)?.icon} alt="" aria-hidden="true" />
);

/**
 * None / Mêlée / Distance: which positional damage% (genConfig.position) the
 * solver, the displayed score and every damage figure count.
 */
const PositionToggle = ({ value = POSITION_NONE, onChange, lang = 'fr', disabled = false }) => (
    <Toggle
        className="position-toggle"
        variant="pill"
        ariaLabel={tr(TXT_POSITION, lang)}
        value={value}
        onChange={onChange}
        disabled={disabled}
        items={[
            {
                value: POSITION_NONE,
                icon: <DoNotDisturbAltIcon />,
                ariaLabel: tr(TXT_NONE, lang),
                tooltip: tr(TXT_NONE, lang),
            },
            {
                value: POSITION_MELEE,
                icon: statIcon(MELEE_PER_DMG_ID),
                ariaLabel: tr(TXT_MELEE, lang),
                tooltip: tr(TXT_MELEE, lang),
            },
            {
                value: POSITION_RANGED,
                icon: statIcon(RANGED_PER_DMG_ID),
                ariaLabel: tr(TXT_RANGED, lang),
                tooltip: tr(TXT_RANGED, lang),
            },
        ]}
    />
);

export default PositionToggle;
